import React, { useEffect, useState } from 'react'

import './PortalOrAgencyForInterview.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
const PortalOrAgencyForInterview = () => {


  
const getInitialFormData = () => {
  const saved = localStorage.getItem('portalAgencyData');
  const jobId = localStorage.getItem('selectedJobId') || '';
  if (saved) {
    try {
      const parsed = JSON.parse(saved);
      return {
        ...parsed,
        jobId,
      };
    } catch (e) {
      console.error("Failed to parse portalAgencyData", e);
    }
  }
  return {
    jobId,
    portal: '',
    agencies: '',
    comments: ''
  };
};

const [formData, setFormData] = useState(getInitialFormData);

  const navigate = useNavigate();
  // Restore saved data on load
  useEffect(() => {
    const saved = localStorage.getItem('portalAgencyData');
    if (saved) {
      setFormData({
        ...JSON.parse(saved),
        jobId: localStorage.getItem('selectedJobId') || ''
      });
    } else {
      setFormData(prev => ({
        ...prev,
        jobId: localStorage.getItem('selectedJobId') || ''
      }));
    }
  }, []);


 useEffect(() => {
  localStorage.setItem('portalAgencyData', JSON.stringify(formData)); // ✅ keeps syncing
}, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const manpowerData = JSON.parse(localStorage.getItem('manpowerData'));
    const portalAgencyData = formData;

    if (!manpowerData || !portalAgencyData) {
      alert("Missing data. Please fill in all previous steps.");
      return;
    }

    const designation = localStorage.getItem('role');
    const employeeName = localStorage.getItem('username');
    //   const positionName = localStorage.getItem('positionName'); // Optional

    const payload = {
      jobId: manpowerData.jobId,
      employeeName,
      designation,
      positionName: manpowerData.positionName,
      openings: manpowerData.openings,
      location: manpowerData.location,
      skills: manpowerData.skillSet,
      experience: manpowerData.selectedExperience,
      reason: manpowerData.reason,
      date: manpowerData.selectedDate?.split('T')[0],
      portal: portalAgencyData.portal,
      agencies: portalAgencyData.agencies,
      comments: portalAgencyData.comments
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/hr/submission`, payload);
      console.log("Submitted successfully", response.data);

      alert("Submitted successfully!");

      // Clear local storage
      localStorage.removeItem('formData');
      localStorage.removeItem('manpowerData');
      localStorage.removeItem('selectedJobId');
     // localStorage.removeItem('portalAgencyData');

      // Reset form state
      setFormData({
        jobId: '',
        portal: '',
        agencies: '',
        comments: ''
      });

      // Optionally, navigate to another page
      // navigate('/some-confirmation-page');

    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit. Please try again.");
    }
  };

  const handlePrevious = () => {
    navigate('/requirementManPowerForInterview');
  };
  const isFormValid = formData.jobId && formData.portal.trim() && formData.agencies.trim();


  return (
    <div>

      <div className='main-div-p-a'>
        <h3 className='headding-p-a'> Job Publication</h3>
        <form onSubmit={handleSubmit}>
          {/* <div className="portal-agency">
            
            <input type="text" placeholder="Job Id" value={formData.jobId} readOnly />
            <label><span className="required">*</span><span className='label-text'>Job&nbsp;Id:</span></label>
          </div> */}
          <div className="portal-agency">
            
            <input type="text" name="portal"
              value={formData.portal} onChange={handleChange} required />
              <label><span className="required">*</span><span className='label-text'>Portal</span></label>
          </div>
          <div className="portal-agency">
            
            <input type="text" name="agencies"
              value={formData.agencies} onChange={handleChange} required />
              <label><span className="required">*</span><span className='label-text'>Agencies</span></label>
          </div>
          <div className="portal-agency">
           
            <input type="text" name="comments"
              value={formData.comments} onChange={handleChange} required/>
               <label><span className='label-text'>Comments</span></label>
          </div>
          <div className='btn-portal'>
            <button type="button" className='portal-agency-btn' onClick={handlePrevious}>Previous</button>
            <button type='submit' className='portal-agency-btn' disabled={!isFormValid}>Submit</button>

          </div>
        </form>
      </div>
    </div>
  )
}

export default PortalOrAgencyForInterview